import React from 'react';
import styles from './footer.module.css';

const Footer = () => {
const currentYear = new Date().getFullYear();

return (
    <footer className={styles.footer}>
    <div className={styles.container}>
        <div className={styles.content}>
        <div className={styles.copyright}>
            <p>&copy; {currentYear} Todos los derechos reservados</p>
            <p>Desarrollado por <a href="https://www.linkedin.com/in/guillerminabousono/">Guillermina</a></p>
        </div>
        
        <div className={styles.socialLinks}>
            <a href="https://www.youtube.com/@LautaroMazzaTango" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <svg className={styles.socialIcon} viewBox="0 0 24 24">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
            </a>
            
            <a href="https://open.spotify.com/intl-es/artist/3h06lfbxW20gjWcdhdBcU0?si=aErsoN_VQxix6vB-5bdV8Q" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <svg className={styles.socialIcon} viewBox="0 0 24 24">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zm-1.049-16.684c-1.338 0-2.418 1.094-2.418 2.444 0 1.35 1.08 2.444 2.418 2.444s2.418-1.094 2.418-2.444c0-1.35-1.08-2.444-2.418-2.444zm9.049 12.684h-8v-1.5h8v1.5zm-8.5-3h8.5v-1.5h-8.5v1.5zm1.5-3h6v-1.5h-6v1.5z"/>
            </svg>
            </a>
            
            <a href="https://www.instagram.com/lautaromazzatangook/" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <svg className={styles.socialIcon} viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            </a>
            
            <a href="https://www.facebook.com/lautaro.mazza2x4" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <svg className={styles.socialIcon} viewBox="0 0 24 24">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10zm-1.524-14.916v1.676h-1.133v2.237h1.133v5.577h2.486v-5.577h1.559v-2.237h-1.559v-1.141c0-.455.244-.676.701-.676h.859v-2.037h-1.404c-1.699 0-2.398.85-2.398 2.398z"/>
            </svg>
            </a>
        </div>
        </div>
    </div>
    </footer>
);
};

export default Footer;